import z from "zod";
export const DTOMCPConsumer = z.object({
    userId: z.string(),
    lastAccessedAt: z.coerce.date(),
});
export const DTOMCPConsumerListResponse = z.object({
    consumers: z.array(DTOMCPConsumer),
});
export const DTOMCPConsumerFiltersQuery = z
    .object({
    workspaceId: z.string().optional(),
    contextId: z.string().optional(),
    designSystemId: z.string().optional(),
})
    .refine((query) => query.workspaceId || query.contextId || query.designSystemId, {
    message: "Provide at least one of workspaceId, contextId, or designSystemId.",
});
